
export const getAuthenticating = state => state.loading || false;
export const getAuthenticatedUser = state =>
  (state.user ? Object.assign({}, state.user) : null);
export const getFromFrame = state => state.fromFrame;
export const getUserToken = state => state.token || null;



// WEBPACK FOOTER //
// ./src/redux/authenticate/selectors.js